import { API_BASE_URL, API_ORIGIN } from '../services/authService';

const PLACEHOLDER_DOMAINS = [
  'via.placeholder.com',
  'placehold.it',
  'placehold.co',
];

// Use API_ORIGIN from authService, with fallback for production
const API_ORIGIN_URL =
  API_ORIGIN ||
  (import.meta.env.PROD
    ? 'https://wasser-pro-api.sherhan1988hp.workers.dev'
    : '') ||
  API_BASE_URL?.replace(/\/api\/?$/, '') ||
  '';

const isRemoteUrl = (url) => /^https?:\/\//i.test(url);

export const isRemotePlaceholderImage = (url) => {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (!trimmed) return false;
  if (!isRemoteUrl(trimmed)) return false;
  const lowerTrimmed = trimmed.toLowerCase();
  return PLACEHOLDER_DOMAINS.some((domain) => lowerTrimmed.includes(domain));
};

const ensureApiAbsolute = (path) => {
  if (!path || typeof path !== 'string') return path;
  if (isRemoteUrl(path)) return path;
  if (path.startsWith('/')) {
    return API_ORIGIN_URL ? `${API_ORIGIN_URL}${path}` : path;
  }
  return path;
};

export const sanitizeImageUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (isRemotePlaceholderImage(trimmed)) return null;
  // Filter out local placeholder images that should be replaced with our SVG
  const lowerUrl = trimmed.toLowerCase();
  if (
    lowerUrl === '/placeholder.jpg' ||
    lowerUrl === '/placeholder.png' ||
    lowerUrl === 'placeholder.jpg' ||
    lowerUrl === 'placeholder.png' ||
    (lowerUrl.includes('placeholder') &&
      !lowerUrl.includes('placeholder-product.svg'))
  ) {
    return null;
  }
  if (trimmed.startsWith('/api/')) {
    const absolute = ensureApiAbsolute(trimmed);
    // HOTFIX: Fallback to hardcoded API URL if resolution fails
    if (!absolute.startsWith('http')) {
      // Only log in development to reduce console spam
      if (!import.meta.env.PROD && !sanitizeImageUrl._warned) {
        console.warn(
          '[sanitizeImageUrl] Using hardcoded fallback URL (this message shown once)'
        );
        sanitizeImageUrl._warned = true;
      }
      return `https://wasser-pro-api.sherhan1988hp.workers.dev${trimmed}`;
    }
    return absolute;
  }
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }
  return trimmed;
};

export const transformApiImageUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  if (url.startsWith('/api/images/')) {
    const keyPart = url.slice('/api/images/'.length);
    const key = decodeURIComponent(keyPart);
    return buildImageUrl(key);
  }
  return sanitizeImageUrl(url);
};

export const transformApiImageUrls = (urls) => {
  if (!Array.isArray(urls)) return [];
  return urls.map((url) => transformApiImageUrl(url)).filter(Boolean);
};

// Build image URL from Worker API (R2-backed)
export const buildImageUrl = (key) => {
  if (!key || typeof key !== 'string') return '';
  const normalizedKey = decodeURIComponent(key.trim());
  const path = `/api/images/${encodeURIComponent(normalizedKey)}`;
  const absolute = ensureApiAbsolute(path);
  // HOTFIX: Fallback to hardcoded API URL if resolution fails
  if (!absolute.startsWith('http')) {
    // Only log in development to reduce console spam
    if (!import.meta.env.PROD && !buildImageUrl._warned) {
      console.warn(
        '[buildImageUrl] Using hardcoded fallback URL (this message shown once)'
      );
      buildImageUrl._warned = true;
    }
    return `https://wasser-pro-api.sherhan1988hp.workers.dev${path}`;
  }
  return absolute;
};
